export const getAvatarURL = (user) =>
  user?.avatarUrl?.trim() ? user.avatarUrl : '/default-avatar.png';
